module.exports = __webpack_public_path__ + "img/icon-chat-youyou.27262abd.png";